import { sleep } from '../modules/Utils';
import Cookies from '../modules/Cookies';

const makeScrollPersist = () => {
  const myMapListNew = $('#myMapListNew');
  const scrollElement = myMapListNew.data('sb')
    ? myMapListNew.data('sb').getScrollElement()
    : myMapListNew[0];

  const debounceSetScrollTop = _.debounce((scrollTop = 0) => {
    Cookies.originalSet('myMapListScrollTop', scrollTop);
  }, 300);

  scrollElement.addEventListener(
    'scroll',
    ({ currentTarget: { scrollTop } }) => {
      debounceSetScrollTop(scrollTop);
    }
  );

  let initialScrolled = false;
  window.myMapListSetInitialScroll = async () => {
    if (
      initialScrolled ||
      Gdata.MyMaps.loaded !== 2 ||
      !myMapListNew.is(':visible')
    ) {
      return;
    }

    console.log('scrolled');

    initialScrolled = true;

    const scrollTop = Cookies.get('myMapListScrollTop');
    if (scrollTop) {
      await sleep(300);
      scrollElement.scrollTo(0, scrollTop);
    }
  };
  $(document).on('click', '.openMyMapList', () => {
    window.myMapListSetInitialScroll();
  });
};

makeScrollPersist();
